import { Highlight, Snippet } from 'react-instantsearch-hooks-web';
import { renderDate } from '../util';
import { HitProps } from './_types';
import { HitHeadline } from './_HitHeading';
import { classnames } from 'tailwindcss-classnames';

export const PageHit = ({ hit }: HitProps) => {
  return (
    <div data-component="PageHit">
      <HitHeadline hit={hit}>
        <Highlight hit={hit} attribute="pageTitle" />
      </HitHeadline>
      {hit.publishedDate && renderDate(hit.publishedDate)}

      <Snippet
        hit={hit}
        attribute="body"
        className={classnames('line-clamp-4', 'md:line-clamp-2')}
      />
    </div>
  );
};
